import Layout from '@/pages/layout';
export default function App() {
  return (
    <Layout />
  );
}